import { Box } from "@mui/material";
import React, { useMemo, memo } from "react";
import { useSearchParams } from "react-router-dom";
import SelectDatePicker from "../../components/Filters/SelectDatePicker";
import Boards from "../../components/Filters/Boards";
import ReplayIcon from "@mui/icons-material/Replay";
import Team from "../../components/Filters/Team";
import { useSelector } from "react-redux";

const MobileFilters = ({ clearFilters, groupingUser, teams }) => {
  const [searchParams] = useSearchParams();
  const oldBoard = useMemo(() => searchParams.get("board"), [searchParams]);
  const oldDate = useMemo(() => searchParams.get("date"), [searchParams]);
  const flattenedUsers = useMemo(
    () => groupingUser.map((item) => item?.users).flat(),
    [groupingUser]
  );

  const groupingUserdata = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  return (
    <Box>
      <div className="filter-head-container">
        <p className="filter-head-mobile">Filter By</p>
        {(oldBoard || flattenedUsers.length > 0 || oldDate) && (
          <div className="d-flex align-items-center" onClick={clearFilters}>
            <ReplayIcon className="reset-mobile-icon" />
            <p className="reset-text-mobile">Reset</p>
          </div>
        )}
      </div>
      <div className="filter-body-container">
        <p className="filter-text">By Date:</p>
        <div
          style={{
            maxHeight: "180px",
            overflow: "auto",
            marginTop: "8px",
          }}>
          <SelectDatePicker />
        </div>

        <div className="mt-4">
          <Team team={teams} />
        </div>

        <div className="mt-4">
          <Boards />
        </div>
      </div>
    </Box>
  );
};

// Memoize the component with a custom comparison function
const arePropsEqual = (prevProps, nextProps) => {
  // Check if clearFilters and teams are the same
  if (
    prevProps.clearFilters !== nextProps.clearFilters ||
    prevProps.teams !== nextProps.teams
  ) {
    return false;
  }

  return (
    JSON.stringify(prevProps.groupingUser) ===
    JSON.stringify(nextProps.groupingUser)
  );
};

export const MemoizedMobileFilters = memo(MobileFilters, arePropsEqual);
